/* src/app/components/user/third-party/third-party.component.scss */
.card-header {
  margin-bottom: 16px;
  padding: 0 16px 10px;
  border-bottom: 1px solid #e0e0e0;
}
:host-context(.dark-theme) .card-header {
  border-bottom: 1px solid #656565;
}
/*# sourceMappingURL=third-party.component.css.map */
